import { fetchAuthSession } from 'aws-amplify/auth';

const CONTENT_TYPE_HEADER = { 'Content-Type': 'application/json' } as const;

/**
 * Build headers for the dedicated Admin API.
 *
 * API Gateway and Lambda both enforce an access-token-only contract. An ID
 * token is intentionally never used as a fallback here.
 */
export async function getAdminApiAuthHeaders(): Promise<Record<string, string>> {
  let session;

  try {
    session = await fetchAuthSession();
  } catch {
    throw new Error('Unable to load the admin session. Sign in again.');
  }

  const accessToken = session.tokens?.accessToken?.toString();
  if (!accessToken) {
    throw new Error('Admin API access token is unavailable. Sign in again.');
  }

  return {
    Authorization: `Bearer ${accessToken}`,
    ...CONTENT_TYPE_HEADER,
  };
}
